module.exports = __webpack_public_path__ + "media/images/business/illust-case-07-d1691ded1ddf7eb13657a3c14d9f61e9.svg";